const get = () => {
    const location = window.location;
    return `${location.protocol}//${location.hostname}${(location.port ? `:${location.port}` : "")}`
}

export default {
    get
};